module.exports = __webpack_public_path__ + "media/images/mailers/facebook-379f10f73d40d8ff8f9605d65ae5d570.png";